import { CRY_TYPE } from '@/common/constants/ConstCode';
import ServiceExec from '@/common/utils/ServiceExec';
import store from '@/store';

const memorialPrefix = '/api/memorial';
const announcementPrefix = '/api/announcement';
const andersenPrefix = '/api/andersen';
const funeralPrefix = '/api/funeral';

export default {
  async getList({ commit, getters, state }, payload) {
    if (payload.nextId == -1) return false;
    if (payload.nextId === null) commit('setList');

    let response;

    if (payload.category === CRY_TYPE.FUNERAL.key) {
      response = await ServiceExec.get(funeralPrefix + '/cry/search', { ...payload });
    } else {
      response = await ServiceExec.get(memorialPrefix + '/cry/search', { ...payload });
    }

    if (response.status !== ServiceExec.status.OK) return;

    const { list, pageInfo } = response.data;
    if (!list || list.length === 0) return;
    commit('setNextId', pageInfo?.nextId);
    commit('appendList', list);
  },

  async fetchRecentEvents({ commit, getters, state }) {
    const userData = store.getters['user/getUserData'];
    if (!userData || !userData.userNo) return;

    const response = await ServiceExec.get('/api/memorial/recent/' + userData.userNo);
    commit('setDetail', response.data || null);
    return response.data;
  }
};
